import UserProfile from "../data";

const filterByPermissions = (items) => {
    const user = UserProfile.getUserData();
    console.log("Filter cost Center", user.level, user.costCenters, user)
    // 1. Acceso total para admin, rrhh o si tiene el comodín "all"
    if (user.level === 'admin' || user.level === 'rrhh' || user.costCenters.includes("all")) {
        return items;
    }

    // 2. Filtrado por Centros de Costo específicos
    if (user.costCenters.length > 0) {
        return items.filter(item => user.costCenters.includes(item.costCenter));
    }

    // 3. Si es nivel usuario básico (opcional, dependiendo de si el employee tiene user.id)
    if (user.level === 'user') {
        // Si el 'employee' tiene un campo que lo vincule al usuario logueado:
        return items.filter(item => item.userId === user.id);
    }

    return [];
};

export default filterByPermissions;